import React, { useState } from 'react';
import { View } from 'react-native';

export default function LinearGradient(props) {
  const [width, setWidth] = useState(1);
  const [height, setHeight] = useState(1);
  const {
    start = { x: 0.5, y: 0 },
    end = { x: 0.5, y: 1 },
    colors = [],
    locations = [],
    useAngle,
    angleCenter,
    angle,
    style,
    children,
    ...restProps
  } = props;

  const measure = ({ nativeEvent }) => {
    setHeight(nativeEvent.layout.height);
    setWidth(nativeEvent.layout.width);
  }

  const getAngle = () => {
    const angle =
      Math.atan2(
        width * (end.y - start.y),
        height * (end.x - start.x)
      ) +
      Math.PI / 2;
    return angle + 'rad';
  };

  const getColors = () =>
    colors.map((color, index) => {
      const location = locations[index];
      let locationStyle = '';
      if (location) {
        locationStyle = ' ' + location * 100 + '%';
      }
      return color + locationStyle;
    }).join(',');

  return (
    <View
      {...restProps}
      style={[
        style,
        { backgroundImage: `linear-gradient(${getAngle()},${getColors()})` },
      ]}
      onLayout={measure}
    >
      {children}
    </View>
  );
}
